import { render, staticRenderFns } from "./brand-list.vue?vue&type=template&id=5b619c45&"
import script from "./brand-list.vue?vue&type=script&lang=js&"
export * from "./brand-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports